/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import axios from 'axios';
import { ACR, BASE_URL, USER_DETAILS } from '../../constant/urls';

import { EventType, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { AUTHORITY, CLIENT_ID, REDIRECTURI } from "../../constant/userConfig";
export const scopes = ["User.Read",];

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: AUTHORITY,
        redirectUri: REDIRECTURI
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const pca = new PublicClientApplication(
    msalConfig,
);

    const accounts = pca.getAllAccounts();
    if (accounts.length > 0) {
        pca.setActiveAccount(accounts[0]);
    }

// axios call for user details and calling event after logged in sucessfully to generate token for every 45 mins
pca.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload;
        const account = payload.account;
        pca.setActiveAccount(account);
       const userCheck =()=>{
            const postdata = {
                "user_ein": account?.idTokenClaims.EIN,
                "first_name": account?.idTokenClaims.given_name,
                "last_name": account?.idTokenClaims.family_name,
                "email_id": account?.idTokenClaims.email,
                "role": account?.idTokenClaims.groups[0],
            }

            axios.post(`${BASE_URL}/${ACR}/${USER_DETAILS}`, postdata)
                .then((res) => {
                    console.log(res)
                })
                .catch((error) => {
                    console.error(error)
                })
            }
            setTimeout(() => {
                userCheck()
            }, 2000);
    
    }

});

setInterval(async () => {
        const  accounts = pca.getAllAccounts();
        if(accounts.length > 0)
        {
            pca.setActiveAccount(accounts[0]);
            try
            {
                const response = await pca.acquireTokenSilent({ scopes, account: accounts[0], forceRefresh: true });
                console.log("setinterval refreshed token",response)
            }
            catch (error)
            {
                console.error("Token refresh error", error);
            }
        }
        
    }, 45*60*1000);


// function checkToken() {
//     if (accounts) {
//         instance.acquireTokenSilent({
//             scopes: ["User.Read"],
//             account: accounts[0]
//         }).then((response) => {
//             if (response) {
//                 callMsGraph(response.idToken)
//                 .then((result) => {

//                     // setApiData(result);
//                     console.log(result)
//                 });
//             }
//         });
//     }
// }
// checkToken();
// export const getAccessToken = async () => {
//     let token = null;
//     const response = await pca.acquireTokenSilent({ scopes });
//     console.log("response", response)
//     try {
//         token = response.idToken;
//         callMsGraph(response.idToken)
//      }
//     catch (error) {
//         console.error(error);
//     }
//     return token;
// };
